import PageComponent from '../base/PageComponent'

export default class Slide extends PageComponent {
    init() {
        this.ready();
    }

    ready() {
        $('.go-slick').slick({
            //infinite: true,
            dots: true,
            speed: 300,
            slidesToShow: 2,
            slidesToScroll: 2,

            prevArrow: '.arrow-prev',
            nextArrow: '.arrow-next',
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        prevArrow: '',
                        nextArrow: '',
                        autoplay: true,
                    }
                }
            ]
        });
    }

}


// WEBPACK FOOTER //
// ./src/js/components/Slide.js